import Geocode from 'react-geocode';

export const getMapCoords = async ({
  location,
  venue,
  isMapOverridden,
  isVenueMapOverridden,
  isVenueAddressOverridden,
}) => {
  const getCoords = async (address, city, state, zipcode) => {
    try {
      const response = await Geocode.fromAddress(
        `${address}, ${city}, ${state} ${zipcode}`,
      );
      const { lat, lng } = response.results[0].geometry.location;
      return { latitude: lat, longitude: lng };
    } catch {
      return { latitude: null, longitude: null };
    }
  };

  const { address, city, state, zipcode, mapLonLat, addressLonLat } =
    location || {};

  const {
    address: venueAddress,
    city: venueCity,
    state: venueState,
    zipcode: venueZipcode,
    venueLonLat,
    venueAddressLonLat,
  } = venue || {};

  if (isVenueMapOverridden && venueLonLat?.latitude && venueLonLat?.longitude) {
    return {
      latitude: venueLonLat.latitude,
      longitude: venueLonLat.longitude,
    };
  }

  if (
    isVenueAddressOverridden &&
    venueAddress &&
    venueCity &&
    venueState &&
    venueZipcode
  ) {
    if (venueAddressLonLat?.latitude && venueAddressLonLat?.longitude) {
      return venueAddressLonLat;
    }
    return await getCoords(venueAddress, venueCity, venueState, venueZipcode);
  }

  if (isMapOverridden && mapLonLat?.latitude && mapLonLat?.longitude) {
    return {
      latitude: mapLonLat.latitude,
      longitude: mapLonLat.longitude,
    };
  }

  if (address && city && state && zipcode) {
    if (addressLonLat?.latitude && addressLonLat?.longitude) {
      return addressLonLat;
    }
    return await getCoords(address, city, state, zipcode);
  }

  return null;
};
